import { render } from "./HeroiconsOutlineChat.vue?vue&type=template&id=49e5d17b"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChat.vue"]])

export default __exports__